/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line no-unused-vars
import axios, { AxiosResponse } from 'axios';
import store from '@/store/index';
import { checkh5Sign } from './checkSign';
import { safeXLogSend } from '@/common/utils/xLogManager';

const extractPath = (url: string): string => {
  try {
    // 构造完整 URL，处理省略协议的情况
    const completeUrl = new URL(url, window.location.origin);
    // 直接返回 pathname，即去掉协议和域名的路径部分
    return completeUrl.pathname;
  } catch (e) {
    return url;
  }
};

const service = axios.create({
  // baseURL: import.meta.env.VITE_BASE_URL,
  timeout: 1000 * 12,
});

service.defaults.timeout = 30000;
service.interceptors.request.use(
  async (config: any) => {
    config.metadata = { startTime: new Date().getTime() };
    if (config.url.indexOf('/ebk-dkb-api/home/get-session-id-by-token') == -1) {
      if (config.url) {
        config.url = `${config.url}?isHeCheng=${store.state.isHeCheng}`;
      }
      //赫程渠道需要拼上token
      if (store.state.isHeCheng) {
        config.url = config.url + '&token=' + store.state.isHeChengToken;
      }
    }
    // 添加头信息
    if (config.headers) {
      // 调用反爬脚本生成签名
      const signData = await checkh5Sign(
        config.method,
        config.url,
        config.method === 'post' ? config.data : config.params,
      );
      if (signData) {
        config.headers[signData.key] = signData.value;
        console.log('signData.key', signData.key);
      }
    }
    return config;
  },
  (error: Error) => {
    Promise.reject(error);
  },
);

service.interceptors.response.use(
  (response: any) => {
    const data = response.data as any;
    //请求事件埋点

    // 计算请求耗时
    const endTime = new Date().getTime();
    const startTime = response.config?.metadata?.startTime;
    const requestCostTime = startTime ? endTime - startTime : -9999;
    const requestParams = response.config.method === 'get' ? response.config.params : response.config.data; // 获取请求参数
    let code = data?.code;
    if (code === undefined) {
      code = data?.retcode;
    }
    if (code === undefined) {
      code = data?.result?.retcode;
    }
    safeXLogSend('http_request', {
      key_referrerChannel: store.state.isHeCheng ? '携程EBooking' : '同程EBooking', // 渠道 ：携程/同程
      int_requestCostTime: requestCostTime, //请求耗时
      key_responseCode: response.status || '', //请求状态
      key_requestPath: response.config.url ? extractPath(response.config.url) : '', //接口地址（域名    xxxx    参数 中间的部分 ）
      key_requestUrl: response.config.url, //完整请求链接
      key_requestTraceId: '', //链路id
      key_appUk: 'hotel.ebooking.front.dkb', // app唯一标识
      key_responseBusinessCode: code ?? '', //业务code
      key_systemName: 'e_booking_PC端', //系统名称
      key_systemCode: 'e_booking_pc', //系统code
      key_extendValue: {
        key_requestParams: JSON.stringify(requestParams) || '', // 请求参数
        key_responseData: JSON.stringify(data) || '', // 返回结果
      },
      key_TcUserId: store.state.userNumber || '', //用户唯一标识
      key_mhotelId: store.state.mhotelId || '', //带客宝酒店ID
      key_shotelId: store.state.shotelId || '', //带客宝供应商ID
      key_plateform: 'e_booking_pc',
    });


    // 判断是否丢失登录态
    if (data.code === 405 || data.code === 403) {
      // 跳转登录
      localStorage.removeItem('loginInfo');
      return false;
    }
    // 可预知的错误提示，统一提示（如：参与校验失败、统一系统异常）
    if (data.code === 2000) {
      return false;
    }
    return data;
  },
  (error: any) => {
    //请求事件埋点

    // 计算请求耗时
    const endTime = new Date().getTime();
    const startTime = error.config?.metadata?.startTime;
    const requestCostTime = startTime ? endTime - startTime : -9999;
    // 获取请求参数
    const requestParams = error.config?.method === 'get' ? error.config?.params : error.config?.data;
    safeXLogSend('http_request', {
      key_error_type: 'requestFailure',
      key_referrerChannel: store.state.isHeCheng ? '携程EBooking' : '同程EBooking',
      int_requestCostTime: requestCostTime, //请求耗时
      key_responseCode: error.response?.status || '',
      key_appUk: 'hotel.ebooking.front.dkb', // app唯一标识
      key_responseStatus: error.response?.status ?? '',
      key_systemName: 'e_booking_PC端', //系统名称
      key_systemCode: 'e_booking_pc', //系统code
      key_requestPath: error.config?.url ? extractPath(error.config.url) : '', //接口地址（域名    xxxx    参数 中间的部分 ）
      key_requestUrl: error.config?.url || '', //完整请求链接
      key_error_info: error.message,
      key_requestTraceId: '', //链路id
      key_extendValue: {
        key_requestParams: JSON.stringify(requestParams) || '',
        key_responseData: error.response?.data || '',
      },
      key_TcUserId: store.state.userNumber || '',
      key_mhotelId: store.state.mhotelId || '',
      key_shotelId: store.state.shotelId || '',
      key_plateform: 'e_booking_pc',
    });

    Promise.reject(error);
  },
);

export default service;
